import { render, staticRenderFns } from "./DeleteTaxDialog.vue?vue&type=template&id=2de9e4b6&scoped=true"
import script from "./DeleteTaxDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTaxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9e4b6",
  null
  
)

export default component.exports